<template>
  <div class="payment-callback">
    <div v-if="loading" class="loading">
      <p>Verifying payment...</p>
    </div>

    <div v-else-if="paymentStatus === 'success'" class="success">
      <h2>Payment Successful!</h2>
      <p>Order has been paid.</p>
      <button @click="redirectToRapportsSalarie">Rapports salarié</button>
    </div>

    <div v-else-if="paymentStatus === 'failed'" class="error">
      <h2>Payment Failed</h2>
      <p>{{ errorMessage }}</p>
      <button @click="retryPayment">Retry Payment</button>
    </div>
  </div>
</template>

<script>
import {invoice} from './paydunyaService'

export default {
  data() {
    return {
      loading: true,
      paymentStatus: null,
      errorMessage: '',
      paymentToken: null,
      countValue: 5
    }
  },
  created() {
    // Extract token from URL or local storage
    this.paymentToken =
        this.$route.query.token

    if (this.paymentToken) {
      this.verifyPayment()
    } else {
      this.handleError('No payment token found')
    }
  },
  methods: {
    goToRapportsSalarie() {
      setTimeout(() => {
        if (this.countValue > 0) {
          this.countValue -= 1
          if (this.countValue === 0) {
            window.location.href = process.env.VUE_APP_JABALI_WEB_BASE_URL + '/agents/rapportssalarie';
          } else {
            this.goToRapportsSalarie()
          }
        }
      }, 1000)
    },
    async verifyPayment() {
      try {
        invoice.confirm(this.paymentToken)
            .then(() => {
              this.loading = false
              // Récupérer le statut du paiement
              // Le statut du paiement peut être soit completed, pending, cancelled

              this.paymentStatus = 'success'

              console.log(invoice.status);

              console.log(invoice.responseText);  // Réponse du serveur

              // Les champs qui suivent seront disponibles si et
              // seulement si le statut du paiement est égal à "completed".

              // Vous pouvez récupérer le nom, l'adresse email et le
              // numéro de téléphone du client en utilisant l'objet suivant
              console.log(invoice.customer); // {name: 'Alioune', phone: '773830274', email: 'aliounebadara@gmail.com'}

              // URL du reçu PDF électronique pour téléchargement
              //console.log(invoice.receiptURL); // 'https://app.paydunya.com/sandbox-checkout/receipt/pdf/test_VPGPZNnHOC.pdf'
              window.open(invoice.receiptURL, '_blank');
              console.log(process.env.VUE_APP_JABALI_WEB_BASE_URL);

              this.goToRapportsSalarie();
            })
            .catch(error => {
              console.log(error);
              this.handleError('Payment not completed')
            })
      } catch (error) {
        this.handleError('Payment verification failed')
      }
    },
    savePaymentDetails(paymentData) {
      // Implement your logic to save payment details
      // Could be local storage, Vuex store, or API call to backend
      console.log('Payment Details:', paymentData)
    },
    handleError(message) {
      this.paymentStatus = 'failed'
      this.errorMessage = message
      this.loading = false
    },
    redirectToRapportsSalarie() {
      this.$router.push('/agents/rapportssalarie')
    },
    retryPayment() {
      this.$router.push('/payduyna/paymentinitiation')
    }
  }
}
</script>